// menuData.js
const menuData = [
    {
      id: 'home',
      title: 'Home',
      link: '/Home',
      subItems: []
    },
    {
      id: 'analysis',
      title: 'Analysis',
      link: '#',
      subItems: [
          { id: 'alerts', title: 'Alerts', link: `/Analysis/Alerts` },
          { id: 'asset', title: 'Asset', link: `/Analysis/Asset` },
          { id: 'whatif', title: 'What-if', link: `/Analysis/WhatIf` },
          { id: 'utility', title: 'Utility', link: `/Analysis/Utility` },
          { id: 'contractor', title: 'Contractor', link: `/Analysis/Contractor` },
          { id: 'service', title: 'Service', link: `/Analysis/Service` }
      ]
    },
    {
      id: 'submit',
      title: 'Submit',
      link: '#',
      subItems: [
        { id: 'serviceRequest', title: 'Service Request', link: '/SubmitPage?type=ServiceRequest' },
        { id: 'conditionReport', title: 'Condition Report', link: '/SubmitPage?type=Report' },
        { id: 'bulletinBoardItem', title: 'Bulletin Board Item', link: `/ComingSoon/${encodeURIComponent('Bulletin Board Item')}` },
        { id: 'utilityBill', title: 'Utility Bill', link: `/UtilityBills` },
        { id: 'vault', title: 'Vault', link: `/Vault` }
      ]
    },
    {
      id: 'manage',
      title: 'Manage',
      link: '#',
      subItems: [
        { id: 'myProfile', title: 'My Profile', link: '/Profile' },
        { id: 'myTeam', title: 'My Team', link: `/ComingSoon/${encodeURIComponent('My Team')}` },
        { id: 'tenants', title: 'Tenants', link: '/Tenants' },
        { id: 'contractors', title: 'Contractors', link: '/Contractors' },
        { id: 'myBuildingSuite', title: 'My Building/Suite', link: '/Buildings' },
        { id: 'requests', title: 'Requests', link: `/ComingSoon/${encodeURIComponent('Requests')}`  },
        { id: 'benefitGoals', title: 'Benefit Goals', link: '/BenefitGoals' }
      ]
    },
    {
      id: 'support',
      title: 'Support',
      link: '#',
      subItems: [
        { id: 'emailSupport', title: 'Email Support', 
          link: 'https://form.jotform.com/241886657096170'},
        { id: 'appFeedback', title: 'App Feedback', 
          link: '/Feedback' },
        { id: 'faqs', title: 'FAQs', link: 'http://buildingassure.com/faq/' }
      ]
    },
    {
      id: 'about',
      title: 'About',
      link: '#',
      subItems: [
        { id: 'aboutApp', title: 'About the App', 
          link: 'http://buildingassure.com/mybuilding-alerts/' },
        { id: 'aboutUs', title: 'About Us', 
          link: 'http://buildingassure.com/about-us/' },
        { id: 'contactUs', title: 'Contact Us', 
          link: 'http://buildingassure.com/contact/' },
        { id: 'privacy', title: 'Privacy', 
          link: 'http://buildingassure.com/privacy/' }
      ]
    },
    {
      id: 'refer',
      title: 'Refer and Get Rewarded',
      link: '/Refer',
      subItems: []
    },
    {
      id: 'logout',
      title: 'Logout',
      link: '#',
      subItems: []
    }
  ];
  
  export default menuData;
  